import BasePaginatorActions from './View';

export { default as BasePaginatorActions } from './View';
export default BasePaginatorActions;